module.exports = __webpack_public_path__ + "static/media/apercu-regular_italic.9b3e85bf.woff2";